import { isTruthy } from "@/utils/guards";
import { apiErrorDetail } from "@/apis/apiError";
import { setDatabaseAccessRevoked } from "@/store/databaseAccessRevokedStore";

const isDatabaseAccessRevokedError = (error: unknown): boolean =>
    apiErrorDetail(error) === "DATABASE_ACCESS_REVOKED";

export const handleApiResponse = async <
    P extends unknown[],
    R extends
        | {
              error: unknown;
              data: unknown;
              response: Response;
              request?: Request;
          }
        | undefined,
>(
    func: (...args: P) => Promise<R>,
    errorMessage: string = "No response received",
    ...args: P
): Promise<Omit<R, "error" | "request">> => {
    const result = await func(...args);

    if (!result) throw new Error(errorMessage);

    const {
        error,
        // @HACK this is for omitting request from the response
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        request: _request,
        ...rest
    } = result;

    if (isTruthy(error)) {
        if (isDatabaseAccessRevokedError(error)) {
            setDatabaseAccessRevoked();
        }
        throw error;
    }

    return rest;
};
